import React, { useCallback, useEffect, useRef, useState } from 'react';
import NotificationButton from 'src/apps/mydb/mainNavigation/topbar/NotificationButton';
import { dashboardFeature } from 'src/chemkit';

export default function DashboardEntry() {
  const featureRef = useRef(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const feature = dashboardFeature.createDashboardFeature({
      onOpenStateChange: ({ isOpen: nextIsOpen, isOpening: nextIsOpening }) => {
        setIsOpen(nextIsOpen);
        setIsOpening(nextIsOpening);
      },
      onRequestClose: () => {
        setIsOpen(false);
      },
    });

    featureRef.current = feature;
    setIsEnabled(feature.isEnabled());

    return () => {
      feature.close();
      featureRef.current = null;
    };
  }, []);

  const openDashboard = useCallback(async () => {
    if (!featureRef.current) {
      return;
    }

    await featureRef.current.open({
      openerEl: document.activeElement,
    });
  }, []);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <NotificationButton
        label={isOpening ? 'Opening...' : 'Dashboard'}
        icon={isOpening ? 'fa-spinner fa-spin' : 'fa-th-large'}
        onClick={openDashboard}
        active={isOpen}
      />
    </>
  );
}
